<template>

<div class="row">
    <div class="col-12 mb-4">
        <input type="text" id='srch-field'
                @focusin='isFocused = true' 
                @focusout='hideResults' 
                @keyup='textFilter($event)'
                class='form-control form-control-lg' :placeholder="inputText" v-model='filter.search'>

        <div id='sb-results' v-show='isFocused'>
            <div v-for='r in catResults' v-if='shouldShow(r)' class='result-item'>
                <a :href='r.url'>{{ ucFirst(r.title) }} </a>
            </div>

            <div v-for='(title,url) in results' class='result-item'>
                <a :href='"/tools/" + url'>{{ title }} </a>
            </div>
        </div>
    </div>

    <div class="col-12">
        <div class="row">
            <div class="col-6 col-lg-2 order-1">
                <button class='btn btn-filters' data-toggle="modal" data-target="#filterModal">
                    <span class="icon icon-settings-vertical mr-2"></span>
                    Filters
                </button>
            </div>
            <div class="col-12 col-lg-8 mt-4 mt-lg-0 order-3 order-lg-2" v-if='isReady'>
                <div id="categories-carousel" class="owl-carousel">
                    
                    <a v-for='c in toolData.cats' :href='"/categories/" + c.url'  
                        :class='["btn btn-secondary btn-lg", filter.cat == c.id ? "active" : ""]'>
                        {{ c.title }}
                    </a>

                </div>
            </div>
            <div class="col-6 col-lg-2 order-2 order-lg-3">
                <label class="label">Sort by</label>
                <select @change='filterResults' class='form-control' v-model='filter.sort'>
                    <option value='new'>New</option>
                    <option value='verified'>Verified</option>
                    <option value='likes'>Popular</option>
                    <option value='recommended'>Recommended</option>
                </select>   
            </div>
        </div>
    </div>

    <div class="modal" id="filterModal">
        <div class="modal-dialog">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Filters</h4>
                    <button type="button" class="close" data-dismiss="modal">
                        <span class="icon icon-cross"></span>
                    </button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    
                    <div v-for='( tags, cat ) in toolData.tags' class="row mb-3">
                        <div class="col-12">
                            <h6 class="secondary-title">{{ cat }}</h6>
                        </div>

                        <div class="col-12 col-sm-6 mb-2" v-for='t in tags'>
                            <div @click='toggle(t)' :class='["tag-item", { selected : filter.tags.includes(t.id) }]'>

                                <span :class='["icon", filter.tags.includes(t.id) ? "icon-checked" : "icon-unchecked"]'></span>
                                {{ t.title }}
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click='filterResults'>Apply Filter</button>
                    <button type="button" class="btn btn-link" @click='clear()'>Clear</button>
                </div>

            </div>
        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();

            var me = this;

            bus.$on('filter-reset', () => {
                me.filter = {
                    search : '',
                    sort : 'new',
                    tags : [],
                    cat   : null
                };
            })
        },

        props : ['c','t'],

        created() {
            
            if( typeof this.c != 'undefined' ) {
                this.filter.cat = parseInt(this.c);
            }

            if( typeof this.t != 'undefined' ) {
                this.filter.tags.push( parseInt(this.t) );
            }

        },

        data() { 

            return {
                isReady : false,
                inputText : "Search for AI Tools and Categories",

                filter : {
                    search : '',
                    sort : 'new',
                    tags : [],
                    cat   : null
                },

                filterLoading : false,

                isFocused : false,
                results : [],

                catResults : [],

                toolData : false
            }
            
        },

        methods : {

            getData() {
                this.ajax.call('tl:gtd', {}, (r) => {
                    if( r.status == 'success' ) {
                        this.toolData = r.data;

                        for( var i = 0; i < r.data.cats.length; i++) {
                            this.catResults.push({
                                title : r.data.cats[i].title,
                                url   : '/categories/' + r.data.cats[i].url,
                            }) 
                        }

                        this.isReady = true;
                        this.$nextTick( () => {
                            this.initCarousel()
                        });
                    }
                })
            },

            hideResults : _.debounce( function() {
                this.isFocused = false;
            } ,200),


            toggle(t) {

                if( typeof this.t != 'undefined' && t.id == this.t ) {
                    return;
                }

                if( this.filter.tags.includes(t.id) ) {
                    this.filter.tags.splice( this.filter.tags.indexOf(t.id), 1);
                } else {
                    this.filter.tags.push( t.id );
                }
            },

            clear() {
                
                this.filter.tags = [];
                
            },

            filterResults() {
                bus.$emit('filter-tools', this.filter );
                $("#filterModal").modal('hide');
            },

            textFilter( ev ) {
                if( ev.key == "Enter" || ev.keyCode == 13 ) {
                    bus.$emit('filter-tools', this.filter );

                    $("#srch-field").blur();
                    return;
                }

                if( ev.key == "Escape" || ev.keyCode == 27 ) {
                   
                   this.filter.search = '';
                   return;
                }

                if( this.filter.search < 2 ) {
                    return;
                }

                this.filterLoading = true;

                this._tf();
            },

            _tf : _.debounce( function() {

                var me = this;

                me.ajax.call('tl:gac', { s : me.filter.search }, (r) => {

                    if( r.status == 'success' ) { 

                        me.results = r.data;

                    } else {
                        
                        $.notify( r.message, 'warning');

                    }

                    me.filterLoading = false;
                })
                
            }, 500),

            shouldShow(r) {
                if( !this.filter.search ) {
                    return true;
                }

                return r.title.toLowerCase().includes( this.filter.search.toLowerCase() );
            },

            initCarousel() {
                // Owl Testimonials Carousel
                $("#categories-carousel").owlCarousel({
                    items:          5,
                    nav:            true,
                    dots:           false,
                    navText:        ['<span class="icon icon-arrow-left1"></span>','<span class="icon icon-arrow-right1"></span>'],
                    autoWidth:      true,
                    loop:           true,
                    center:         true,
                    margin:         10,
                    responsiveClass: true,
                    responsive: {

                        0:{
                            items:  2,
                            nav:    true
                        },

                        600:{
                            items:  3,
                            nav:    false
                        },

                        1000:{
                            items:  5,
                            nav:    true,
                        }
                    }
                });
            }
        }

    }
</script>
<style type="text/css">

    .tag-item {
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .tag-item .icon {
        font-size: 1.3rem;
        margin-right: 5px;
    }

    .tag-item.selected .icon {
        background: linear-gradient(270deg, #00E7E7 -42%, #006CAB 98%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    #sb-results { 
        position: absolute;
        z-index: 99;
        background: rgba(2, 2, 2, 0.9);
        width: calc(100% - 30px);
        padding: 10px;
        max-height: 40vh;
        overflow: auto;
    }

    .result-item a { 
        display: block;
        width: 100%;
        padding: 4px;
        color: #fff;
    }

    .result-item a:hover {
        background: rgba(0, 161, 255, 0.1);
        color: #00A1FF;
    }

</style>